import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

import {addPrefix} from '@repo/shared/lib/type_utils';

import {CssReset} from '@repo/shared-web/components/core/css_reset';
import {GlobalStyle} from '@repo/shared-web/components/core/global_styles';
import {ThemeContext} from '@repo/shared-web/theme/theme_context';

import {App} from '@repo/website-frontend/components/app';
import {theme} from '@repo/website-frontend/theme';

const container = document.querySelector('#root');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <ThemeContext.Provider value={theme}>
        <CssReset />
        <App />
        <GlobalStyle {...addPrefix(theme.main, '$')} />
      </ThemeContext.Provider>
    </StrictMode>,
  );
}
